import { AiwynPaymentMethod, BillingDetails, PaymentMethodType } from '@aiwyn/api';
import { PaymentMethodMode } from '../../models';

export class GetStripeUserDetails {
  static readonly type: string = '[StripeState] GetStripeUserDetails';
}

export class GetSetupIntentClientSecret {
  static readonly type: string = '[StripeState] GetSetupIntentClientSecret';
  constructor(public forceRefresh: boolean = false) {}
}

export class GetSetupIntentClientSecretByBusinessEntity {
  static readonly type: string = '[StripeState] GetSetupIntentClientSecretByBusinessEntity';
  constructor(public forceRefresh: boolean = false) {}
}

export class SetSelectedBusinessEntityId {
  static readonly type: string = '[StripeState] SetSelectedBusinessEntityId';
  constructor(public readonly businessEntityId: number) {}
}

export class SetSuccessfulSetupIntentId {
  static readonly type: string = '[StripeState] SetSuccessfulSetupIntentId';
  constructor(public paymentMethodId: string, public setupIntentId: string) {}
}

export class GetSavedPaymentMethods {
  static readonly type: string = '[StripeState] GetSavedPaymentMethods';
}

export class SetPaymentMethodMode {
  static readonly type: string = '[StripeState] SetPaymentMethodMode';
  constructor(public paymentMethodMode: PaymentMethodMode) {}
}

export class SetNewPaymentMethodType {
  static readonly type: string = '[StripeState] SetNewPaymentMethodType';
  constructor(public newPaymentMethodType: PaymentMethodType) {}
}

export class SetSelectedSavedPaymentMethodId {
  static readonly type: string = '[StripeState] SetSelectedSavedPaymentMethodId';
  constructor(public selectedPaymentMethodId: string) {}
}

export class SetTemporaryPaymentMethod {
  static readonly type: string = '[StripeState] SetTemporaryPaymentMethod';
  constructor(public temporaryPaymentMethod: AiwynPaymentMethod) {}
}

export class RemoveTemporaryPaymentMethod {
  static readonly type: string = '[StripeState] RemoveTemporaryPaymentMethod';
}

export class SetNewBillingDetails {
  static readonly type: string = '[StripeState] SetNewBillingDetails';
  constructor(public newBillingDetails: BillingDetails) {}
}

export class RemoveNewBillingDetails {
  static readonly type: string = '[StripeState] RemoveNewBillingDetails';
}

export class SetProvidedBillingEmail {
  static readonly type: string = '[StripeState] SetProvidedBillingEmail';
  constructor(public providedBillingEmail?: string) {}
}

export class UpdatePaymentMethodBillingDetails {
  static readonly type: string = '[StripeState] UpdatePaymentMethodBillingDetails';
  constructor(public paymentMethodId: string, public newBillingDetails: BillingDetails) {}
}

export class SavePaymentMethod {
  static readonly type: string = '[StripeState] SavePaymentMethod';
  constructor(public paymentMethodId: string, public setupIntentId: string) {}
}

export class SetDefaultPaymentMethod {
  static readonly type: string = '[StripeState] SetDefaultPaymentMethod';
  constructor(public paymentMethodId: string) {}
}

export class DeletePaymentMethod {
  static readonly type: string = '[StripeState] DeletePaymentMethod';
  constructor(public paymentMethodId: string) {}
}
